import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from '../../../services/environment.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  toShowLabel = this.env.envVariables.companyName;

  constructor(private env: EnvironmentService) { }

  ngOnInit(): void {
  }

}
